import { useMemo } from 'react';

import * as monthUtils from '@actual-app/core/shared/months';
import { q } from '@actual-app/core/shared/query';

import {
  calcularMesesCubiertos,
  HORIZONTE,
} from '#components/mobile/inicio/mesesCubiertos';
import type { MesesCubiertos } from '#components/mobile/inicio/mesesCubiertos';
import { useQuery } from '#hooks/useQuery';

/** `YYYY-MM` → entero de `zero_budgets.month` (202610). */
function mesEntero(mes: string): number {
  return Number(mes.replace('-', ''));
}

/** Entero de `zero_budgets.month` → `YYYY-MM`. */
function mesTexto(mes: number): string {
  const texto = String(mes);
  return `${texto.slice(0, 4)}-${texto.slice(4, 6)}`;
}

/**
 * Lo asignado por mes (sin categorías de ingreso) desde el mes actual hasta
 * un año por delante, y los meses cubiertos que salen de ahí. Solo cuenta lo
 * que se pone en las categorías: un asignado negativo es dinero que se saca
 * de una categoría (p. ej. de «Moviments» para repartirlo), no un mes con
 * menos dinero.
 */
export function useMesesCubiertos(month: string): {
  datos: MesesCubiertos;
  cargando: boolean;
} {
  const { data, isLoading } = useQuery<{ month: number; amount: number }>(
    () =>
      q('zero_budgets')
        .filter({
          month: {
            $gte: mesEntero(month),
            $lte: mesEntero(monthUtils.addMonths(month, HORIZONTE)),
          },
          amount: { $gt: 0 },
          'category.is_income': false,
          'category.tombstone': false,
        })
        .groupBy(['month'])
        .select(['month', { amount: { $sum: '$amount' } }]),
    [month],
  );

  const datos = useMemo(() => {
    const asignadoPorMes = new Map<string, number>();
    for (const fila of data ?? []) {
      asignadoPorMes.set(mesTexto(fila.month), fila.amount ?? 0);
    }
    return calcularMesesCubiertos({ mesActual: month, asignadoPorMes });
  }, [data, month]);

  return { datos, cargando: isLoading };
}
